var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-900 -430)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(900 430)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(998.482 461) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.586,54.81a9.672,9.672,0,1,0,9.672-9.672A9.672,9.672,0,0,0,51.586,54.81ZM3.224,51.586H41.913a3.224,3.224,0,1,1,0,6.448H3.224a3.224,3.224,0,1,1,0-6.448Zm19.345-9.672a9.672,9.672,0,0,1-9.092-6.448H3.224a3.224,3.224,0,1,1,0-6.448H13.477a9.672,9.672,0,1,1,9.092,12.9Zm45.138-6.448H41.913a3.224,3.224,0,1,1,0-6.448H67.706a3.224,3.224,0,1,1,0,6.448ZM29.017,12.9H3.224a3.224,3.224,0,1,1,0-6.448H29.017a3.224,3.224,0,1,1,0,6.448Zm38.689,0H57.454a9.672,9.672,0,1,1,0-6.448H67.706a3.224,3.224,0,1,1,0,6.448Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType9);
export default __webpack_public_path__ + "static/media/aioa-icon-type-9.52139b57cc654c1920a0acf00614fe6e.svg";
export { ForwardRef as ReactComponent };